var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoteWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.112,
    height: 564.477,
    viewBox: "0 0 800.112 564.477",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-447.337 -224.08)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.007,0h8.338V57.672H24.007A24.007,24.007,0,0,1,0,33.665v-9.6A24.007,24.007,0,0,1,24.007,0Z",
    transform: "translate(811.804 361.076) rotate(180)",
    fill: "#dfe6f5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.154,
    height: 57.623,
    rx: 6.03,
    transform: "translate(786.535 361.075) rotate(180)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(772.38 303.404)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.007,0h8.338V57.672H24.007A24.007,24.007,0,0,1,0,33.665v-9.6A24.007,24.007,0,0,1,24.007,0Z",
    transform: "translate(39.422 57.672) rotate(180)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.154,
    height: 57.623,
    rx: 6.03,
    transform: "translate(14.154 57.672) rotate(180)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 145.733,
    height: 151.168,
    transform: "translate(646.031 333.931)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.256,372.333l-8.8,63.928-4.145,30.048-1.525,11.036-12.776,24.906-23.46,45.707L334.3,553.393,254.69,441.128s-41.68-79.655,21.69-72.422c35.532,4.066,43.987-27.741,44.622-56.469a213.6,213.6,0,0,0-3.91-43.107l63.361,30.781q-2.209,10.293-3.323,18.914c-3.089,23.518-.528,38.181,4.829,47.066C396.22,389.556,430.256,372.333,430.256,372.333Z",
    transform: "translate(356.533 86.97)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.321,
    cy: 73.321,
    r: 73.321,
    transform: "translate(640.147 260.159)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.546,589.1c-2.209,8.8,3.363,23.919,10.752,38.767-35.434,3.812-74.289,1.828-74.289,1.828l-39.872,10.87L201.9,673.15c-4.887-6.324-8.8-14.271-12.033-23.225l11.124-12.981c35-21.387,46.44-48.122,48.112-71.66a100.68,100.68,0,0,0-3.089-31.758,106.312,106.312,0,0,0-9.716-25.112l104.19.489h.88l8.563,19.462.391.88,6.373,14.477,21.72-38.924,7.536-12.179,4.223-6.842s62.461-14.506,63.37,22.639a99.209,99.209,0,0,1-.5,12.766c-3.108,29.872-19.452,49.734-32.99,63.273A9.775,9.775,0,0,0,417.546,589.1Z",
    transform: "translate(357.69 82.155)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.867,635.765c-1.808,21.72-54.309-7.243-54.309-7.243s-16.295-5.435-71.513-40.732a168.6,168.6,0,0,1-63.537-74.181,106.544,106.544,0,0,1-5.288-14.525L502.264,471l11.094,16.959,36.881,56.352,54.309,36.167S660.675,614.045,658.867,635.765Z",
    transform: "translate(351.513 82.425)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.33,629.244H60.23l79.7-27.414,199.239-68.541,127.05-43.709H629.861Z",
    transform: "translate(389.515 142.611)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.524,650.72l-2.074,16.7H857.563l-1.38-16.7Z",
    transform: "translate(389.887 121.134)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.606,440.11l-5.669,41.054-12.776,24.906a77.887,77.887,0,0,0-24.261-2.278c9-1.241,14.819-57.5,14.819-57.5l.518-.117Z",
    transform: "translate(353.366 83.121)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.675,486.314c-18.1-2.717-38.924,23.538-38.924,23.538s-24.437,23.538-40.732,7.243c-15.786-15.786-43.459-13.685-45.179-13.587,9-1.251,14.819-57.506,14.819-57.506l.518-.117,86.869-19.315s5.181,7.937,11.026,18.044C506.619,462.825,519.326,488.064,507.675,486.314Z",
    transform: "translate(353.345 83.425)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.464,374.562l-8.8,63.928-4.145,30.048c-12.14-.909-26.861-2.541-26.861-2.541s15.386-64.27-9.961-97.749c0,0,.538,0,1.505-.1C399.428,391.786,433.464,374.562,433.464,374.562Z",
    transform: "translate(353.326 84.741)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.61,368.219s46.167-3.617,64.27,9.052S489,429.179,489,429.179L495.93,444S485.1,445.157,486,446.975s-14.486,10.86-21.72,8.142-25.346,11.73-27.155,13.577-42.54-2.717-42.54-2.717S409.956,401.708,384.61,368.219Z",
    transform: "translate(353.305 84.75)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.6,614.785c-20.82,24.437-127.63,19.012-127.63,19.012l-39.833,10.85L197.9,677.236C171.5,643.024,172.09,561.492,173.527,528.512c.391-8.856.831-14.213.831-14.213s38.014-23.538,55.218,0c3.069,4.193,5.64,10.058,7.82,16.862,9.98,31.368,11.2,82.705,11.2,82.705l45.258-4.526,65.755-15.64a59.412,59.412,0,0,1,13.831-1.613C400.7,592.166,495.472,593.808,477.6,614.785Z",
    transform: "translate(358.07 81.686)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,526.6s-8.142,1.808-24.437-1.808-22.629,3.617-31.68,7.243-32.589,5.435-41.641,1.808-18.1-10.86-37.144-2.717-31.68-8.152-50.683-6.373-31.68-7.243-31.68-7.243l20.195-46.646,6.06-14.007L309.437,446.5h.723Z",
    transform: "translate(358.999 82.977)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.655,374.624s-49.783-9.961-73.311,2.717-41.631,40.732-41.631,40.732-14.263,37.864-12.295,48.874,33.106,0,33.106,0,38.923-9.052,44.358,4.526,30.781,6.334,30.781,6.334,52.5-14.486,62.461,1.808Z",
    transform: "translate(358.492 84.679)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.774,442.555c-4.477,11.788-17.751,17.663-30.165,19.9a99.6,99.6,0,0,1-36.978-.332,74.348,74.348,0,0,0,19.99-41.054c3.333-24-5.239-48.493-1.711-72.451,3.626-24.6,19.657-46.186,22.433-70.9-5.513,3.558-11.857-3.206-14.75-9.1a240.157,240.157,0,0,1-13.4-33.567c-4.487-14.291-8.5-30.3-20.84-38.787-2.18-1.505-5.122-2.717-7.38-1.32-1.652.977-2.3,3.04-2.776,4.887-4.242,16.617-25.688,29.676-31.759,45.737-5.777,15.239-16.2,28.347-21.9,43.645-13.059,34.994,21.407,78.14,23.46,115.441.919,16.471-.45,32.98-1.818,49.412-.225,2.629-.645,5.6-2.825,7.077a8.319,8.319,0,0,1-4.672.977,63.839,63.839,0,0,1-21.514-3.6c-2.786-.977-5.581-2.17-8.533-2.219-4.36-.068-8.328,2.326-12.512,3.578-14.105,4.242-28.787-4.839-39.031-15.415s-18.924-23.391-32.1-29.931c-4.311-2.15-9.951-5.259-8.8-9.941A9.461,9.461,0,0,1,209,400.494c5.337-5.366,10.948-10.557,15.317-16.735,6.588-9.335,10.019-20.469,13.362-31.4,4.829-15.816,9.706-32.022,8.8-48.532-.43-8.182-2.287-16.226-3-24.437-1.408-16.265,1.779-32.531,4.946-48.542,2.15-10.909,4.487-22.218,11.2-31.084,4.565-6.021,10.84-10.488,15.962-16.05,7.644-8.3,12.434-18.758,18.631-28.191s14.6-18.367,25.63-20.762c6.676-1.456,13.626-.342,20.371.782,5.386.909,10.9,1.847,15.992,3.91,4.017,1.6,7.712,5.562,11.828,6.315,8.191,1.535,17.194-1.681,25.962.391,17.057,4.017,32.619,15.454,40.184,31.436a71.945,71.945,0,0,1,3.734,9.775c1.447,4.692,2.551,9.491,3.646,14.281.235.977.459,2.033.674,3.04h0c6.7,31.827,2.375,55-.547,88.111s-3.636,77.466,5.572,109.478C451.106,415.654,458.7,429.584,453.774,442.555Z",
    transform: "translate(357.326 90.011)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.918,510.3v59.744a43.253,43.253,0,0,1-9.325,26.891,44.634,44.634,0,0,1-3.314,3.734,43.449,43.449,0,0,1-61.582,0,44.644,44.644,0,0,1-3.314-3.734A43.254,43.254,0,0,1,248,570.044V510.3a43.215,43.215,0,0,1,10.039-27.78,41.281,41.281,0,0,1,3.724-3.91,43.41,43.41,0,0,1,59.382,0c.352.313.694.655,1.036.977.977.977,1.828,1.955,2.688,2.932a43.214,43.214,0,0,1,10.049,27.78Z",
    transform: "translate(356.381 82.518)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 560.228)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 569.28)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 578.331)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 587.383)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 596.435)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 605.486)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 614.538)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 623.599)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 632.65)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 641.702)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 650.753)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 659.804)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 668.857)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(626.111 677.909)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.728,480.7a2.717,2.717,0,0,1-4.448,2.092A41.284,41.284,0,0,1,262,478.88,2.659,2.659,0,0,1,262.728,480.7Z",
    transform: "translate(356.15 82.248)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 569.28)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 578.331)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 587.383)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 596.435)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 605.486)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 614.538)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 623.599)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 632.65)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 641.702)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 650.753)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 659.804)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(613.442 668.857)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.711,601.067a2.708,2.708,0,0,1-1.847,2.571,44.6,44.6,0,0,1-3.314-3.734,2.708,2.708,0,0,1,5.161,1.163Z",
    transform: "translate(356.166 79.558)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 560.228)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 569.28)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 578.331)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 587.383)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 596.435)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 605.486)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 614.538)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 623.599)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 632.65)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 641.702)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 650.753)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 659.804)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 668.857)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(638.788 677.909)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 560.228)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 569.28)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 578.331)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 587.383)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 596.435)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 605.486)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 614.538)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 623.599)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 632.65)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 641.702)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 650.753)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 659.804)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 668.857)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(651.457 677.909)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 560.228)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 569.28)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 578.331)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 587.383)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 596.435)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 605.486)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 614.538)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 623.599)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 632.65)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 641.702)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 650.753)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 659.804)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 668.857)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(664.134 677.909)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.548,482.789A2.717,2.717,0,0,1,322.1,480.7a2.659,2.659,0,0,1,.723-1.838c.352.313.694.655,1.036.977C324.8,480.8,325.687,481.773,326.548,482.789Z",
    transform: "translate(354.713 82.248)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 569.28)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 578.331)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 587.383)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 596.435)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 605.486)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 614.538)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 623.599)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 632.65)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 641.702)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 650.753)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 659.804)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.717,
    cy: 2.717,
    r: 2.717,
    transform: "translate(676.803 668.857)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.261,599.894a44.622,44.622,0,0,1-3.314,3.734,2.717,2.717,0,1,1,3.314-3.734Z",
    transform: "translate(354.713 79.558)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.668,
    height: 121.296,
    rx: 5.4,
    transform: "translate(639.696 648.036)",
    fill: "#54576b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 86.899,
    height: 16.295,
    rx: 6.95,
    transform: "translate(602.583 753.038)",
    fill: "#54576b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.359,
    cy: 1.359,
    r: 1.359,
    transform: "translate(816.201 746.703)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.6,205.119c-14.946-26.93-45.287-45.394-80.154-45.394-49.656,0-90.066,37.36-90.066,83.282H267c0-49.412,43.254-89.616,96.4-89.616,30.771,0,58.219,13.47,75.882,34.408,1.447,4.692,2.551,9.491,3.646,14.281C443.172,203.1,443.4,204.112,443.6,205.119Z",
    transform: "translate(355.953 89.576)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.337,156h8.338v57.672h-8.338a24.007,24.007,0,0,1-24.007-24.007v-9.6A24.007,24.007,0,0,1,250.337,156Z",
    transform: "translate(386.085 150.121)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.154,
    height: 57.623,
    rx: 6.03,
    transform: "translate(637.684 306.17)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(669.569 524.7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.02,641.858,592.447,619.19l2.717,43.449-100.847,8.172a65.861,65.861,0,0,1-20.732-1.583L369.835,644.7a1.447,1.447,0,0,1,.186-2.844Z",
    transform: "translate(-368.728 -445.725)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.985,643.724,541.6,631.74l1.437,22.971-53.322,4.33a34.829,34.829,0,0,1-10.967-.85l-54.857-12.971a.762.762,0,0,1,.1-1.5Z",
    transform: "translate(-369.957 -446.008)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.315,391.88l227.891-2.81a24,24,0,0,1,15.1,6.683,15.757,15.757,0,0,1,4.711,13.434L772.165,584c-1.276,8.667-10,15.352-20.732,15.877l-232.925,11.71a25.076,25.076,0,0,1-17.707-5.814c-4.524-4-6.587-9.45-5.616-14.826l30.928-183.716C527.835,397.68,538.494,390.921,550.315,391.88Z",
    transform: "translate(-371.57 -389.07)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.86,
    cy: 10.86,
    r: 10.86,
    transform: "translate(274.995 73.439)",
    fill: "#f2f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteWorker);
export default __webpack_public_path__ + "static/media/remote-worker.c0b956aed26d6aca9e275d92b52c4358.svg";
export { ForwardRef as ReactComponent };